export default "__VITE_ASSET__CHLMqB06__"